module.exports = __webpack_public_path__ + "static/media/BellaBona.8c692530.png";